import { SortingRule } from 'react-table';
import * as DT from '../datatable';
import {
  Data,
  Table,
  Device,
  PKey,
  DeviceExtension,
  Totals,
  TotalsByType,
  Log,
  Historical,
  ActionStatus,
  FilterCritria,
  State,
  Statuses,
} from './model';
import { getPK } from './utils';
import { PKeyMap } from './mappings';
import { criterionNames } from '../../interfaces';
import { IHistoricalDefault } from '../historical';

export const FilterCriteriaDefault: FilterCritria = {
  serialNumber: '',
  snLabel: '',
  orderNumber: '',
  deviceName: '',
  owner: '',
  userWithReadRights: '',
  deviceStatus: Statuses.Active,
};

export const DevicePkDefault = (pk: PKey): PKey => PKeyMap(pk);

export const DeviceDefault = (pk: PKey): Device => {
  return {
    ...DevicePkDefault(pk),
    deviceName: '',
    deviceType: -1,
    isActive: false,
    orderNumber: '',
    owner: '',
    userWithReadRights: '',
    availability: -1,
    customerDeviceNo: '',
    showOrderNumber: true,
  };
};

export const DeviceExtensionDefault: DeviceExtension = {
  programNumber: '',
  configurationNumber: '',
  // longDeviceName: "",
  typeNumber: '',
  consumptionType: -1,
  manuallyAssignedOwnership: false,
};

export const TotalsDefault: Totals = {
  totalConcentrators: 0,
  totalGateways: 0,
  totalMeters: 0,
  totalRepeaters: 0,
  totalValves: 0,
};

export const TotalsByTypeDefault: TotalsByType = {
  ...TotalsDefault,
};

export const DataDefault: Data = {
  pages: [],
  pageSize: 100,
  total: 0,
  version: 0,
  totalsByType: TotalsByTypeDefault,
};

export const TablePaginationDefault: DT.TablePagination = {
  currentPage: 1,
  numPages: 1,
  pageSize: 15,
};

export const TableDefault: Table = {
  content: [],
  isLoading: false,
  pagination: TablePaginationDefault,
  columns: [],
};

export const SelectionDefault: DT.ItemSelection<Device> = {
  isAllSelected: false,
  selectedKeys: [],
  getPK,
};

export const LogDefault: Log = {
  datetime: '',
  eventMessage: -1,
  userName: '',
  customerName: '',
};

export const HistoricalDefault: Historical = IHistoricalDefault();

export const ActionStatusDefault: ActionStatus = {
  isDownloadFetching: false,
  isDeactiving: false,
  isActivating: false,
};

export const SortDefault: SortingRule = {
  id: criterionNames.serialNumber,
  desc: true,
};

export const StateDefault: State = {
  filters: FilterCriteriaDefault,
  sort: [SortDefault],
  selection: SelectionDefault,
  data: DataDefault,
  table: TableDefault,
  pagesToLoad: [1],
  actionStatus: ActionStatusDefault,
  activeModal: undefined,
};
